<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="fit-content"
    maxWidth="90%"
    class="bg-white"
    :content-class="isDarkMode ? 'dark-mode' : 'bg-white'"
  >
    <div class="pa-2">
      <div class="wrapper-2 pa-1">
        <div
          v-html="htmlReport"
          style="max-height: 600px; overflow: auto; direction: ltr"
        ></div>
      </div>
    </div>
    <div class="d-flex justify-end">
      <Button
        :clickAction="closeBtnClicked"
        :text="$t('Close')"
        btnType="grey"
        width="100"
        class="ma-2"
      />
    </div>
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ReportHtmlDialog',
  data() {
    return {
      dialog: true,
    }
  },
  props: {
    htmlReport: String,
    closeDialog: Function,
  },
  components: { Button },
  computed: {
    ...mapGetters(['isDarkMode']),
  },
  mounted() {
    console.log('htmlReport: ', this.htmlReport)
  },
  methods: {
    closeBtnClicked() {
      this.closeDialog()
    },
  },
}
</script>

<style scoped src="../UploadReportDialog.css"></style>
